import { Language, Product, ProductId } from "./types";

interface Props {
	products: Product[];
	lang: Language;
	onSelect: (id: ProductId) => void;
}

const ARTICLE_CODE = { EN: "Article code", NL: "Artikelcode" } as const;

export default function ProductPicker({ products, lang, onSelect }: Props) {
	return (
		<div className="faq-picker" role="group" aria-label="Choose your product">
			{products.map((p) => (
				<button
					key={p.id}
					type="button"
					className="faq-product"
					aria-label={`${p.name}, ${ARTICLE_CODE[lang].toLowerCase()} ${p.id}`}
					onClick={() => onSelect(p.id)}
				>
					<span className="faq-product__image">
						<img className="faq-product__photo" src={p.image} alt="" />
					</span>
					<span className="faq-product__code">
						{ARTICLE_CODE[lang]}: {p.id}
					</span>
				</button>
			))}
		</div>
	);
}
